import { useNavigate } from "react-router-dom";
import { AdminHeader } from "@trillion/ui/components/admin/admin-header";
import { PageHeader } from "@trillion/ui/components/admin/page-header";
import { toast } from "sonner";
import { adminApi } from "@/lib/admin-api";
import { IntentForm } from "@/components/intents/intent-form";
import type { IntentFormData } from "@/components/intents/intent-form";

export function IntentNewPage() {
  const navigate = useNavigate();

  async function handleCreate(data: IntentFormData) {
    await adminApi.intents.create({
      source_type: data.sourceType,
      source_key: data.sourceKey,
      topic: data.topic,
      category: data.category || undefined,
      buying_stage: data.buyingStage,
      channel: data.channel || undefined,
      confidence: data.confidence,
      greeting: data.greeting || undefined,
      suggestion_chips: data.suggestionChips.length ? data.suggestionChips : undefined,
      geo_relevance: data.geoRelevance || undefined,
    });
    toast.success("Intent created successfully");
    navigate("/intents");
  }

  return (
    <div className="flex flex-col">
      <AdminHeader
        title="New Intent"
        breadcrumbs={[
          { label: "Dashboard", href: "/" },
          { label: "Intents", href: "/intents" },
          { label: "New" },
        ]}
      />
      <div className="flex flex-col gap-6 p-6">
        <PageHeader
          title="Create Intent"
          description="Add a new traffic intent classification"
        />
        <IntentForm onSubmit={handleCreate} submitLabel="Create Intent" />
      </div>
    </div>
  );
}
